import { render } from "./Accounts.vue?vue&type=template&id=f95318b8"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"
script.render = render

export default script